import { Injectable } from '@angular/core';

import { Setting } from '@frontend/shared/models';
import { RestService } from '@frontend/shared/services/rest.service';

@Injectable({ providedIn: 'root' })
export class SettingsService extends RestService<Setting> {
	protected urlPrefix: string = '/api/appsettings';
}
